/* eslint-disable camelcase */
import React, {
} from 'react';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';

const getPlanAmount = ({ plan }) => {
  if (!plan) {
    return '$ 0.00';
  }
  return `$ ${String(plan.amount).slice(0, -2) || 0}.${String(plan.amount).slice(-2)}`;
};

type Props = {
  isPro: boolean,
  subscription: any,
  onCancel: { (): void },
};

const SubscriptionItem = ({
  isPro,
  subscription,
  onCancel,
}: Props) => (
  <S.Container>
    <Flex column>
      <Text
        size="22px"
        color={subscription.cancel_at_period_end ? '#9ea0a1' : '#333'}
        lineHeight="22px"
      >
        {subscription.plan.name || 'Free Trial'}
      </Text>
      {isPro && (
        <Text
          color="#808080"
          lineHeight="28px"
        >
          {subscription.plan?.metadata?.clients_count}
        </Text>
      )}
    </Flex>

    {subscription.plan.amount && (
      <Flex column width="285px" shrink="0">
        <Flex align="center" spacing={15}>
          <Text
            size="18px"
            color={subscription.cancel_at_period_end ? '#9ea0a1' : '#333'}
          >
            <Text size="22px" weight="bold">
              {getPlanAmount(subscription)}
            </Text>
            {`/${subscription.plan.interval === 'year' ? 'yr' : 'mo'}`}
          </Text>

          {subscription.cancel_at_period_end ? (
            <S.Status status="canceled">
              Canceled
            </S.Status>
          ) : (
            <>
              <S.Status status={subscription.status}>
                {subscription.status.replace('_', ' ')}
              </S.Status>

              <S.CancelSubscriptionButton
                onClick={onCancel}
              >
                Cancel
              </S.CancelSubscriptionButton>
            </>
          )}
        </Flex>
      </Flex>
    )}
  </S.Container>
);

export default SubscriptionItem;
